// extracted by mini-css-extract-plugin
export default {"floatingArea":"g_H","show":"g_J"};